<template>
    <Sidebar v-model:visible="showSidebar" :blockScroll="true" :dismissable="!isLoading" position="right"
        class="vehicle-page-flow p-sidebar-sm">
        <template #header="slotProps">
            <p>{{ vehicle.ModelName }}</p>
            <p class="vehicle-page-flow__header-vehicle-trim">{{ vehicle.ModelTrim }}</p>
        </template>
        <FlowSteps :steps="steps.filter(x => x.visible)" :currentStep="currentStep" />
        <div class="vehicle-page-flow__vehicle-card">
            <div class="vehicle-page-flow__vehicle-card-image">
                <img :src="vehicle.ImageUrl" alt="" loading="lazy" />
            </div>
            <div class="vehicle-page-flow__vehicle-card-info">
                <p class="vehicle-page-flow__vehicle-card-name">{{ vehicle.ModelName }}</p>
                <p>{{ vehicle.ModelTrim }}</p>
                <div class="vehicle-page-flow__vehicle-card-location">
                    <img src="/assets/images/mapmarker.svg" height="25" width="18" loading="lazy" alt="" />
                    <p>{{ vehicle.DealerCity.toLowerCase().includes("amager") ? dictionary.vehicleCommonLocationIsland :
        dictionary.vehicleCommonLocation }} {{ vehicle.DealerCity }}</p>
                </div>
                <p class="vehicle-page-flow__vehicle-card-price" v-if="vehicle.Price > 0" aria-label="Pris">
                </p>
                <p class="vehicle-page-flow__vehicle-card-price" v-else="vehicle.LeasingPrice > 0" aria-label="Pris">
                    {{ vehicle.LeasingPrice.toLocaleString(culture) }} kr./mdr. {{ dictionary.vehicleCommonExcludingVat
                    }}
                </p>
            </div>
        </div>
        <!-- STEP 1 -->
        <div v-if="currentStep == 0" class="vehicle-page-flow__content">
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleOrderFlowHeadline }}</p>
                <p class="vehicle-page-flow__text" v-html="dictionary.vehicleOrderFlowText">
                </p>
            </div>
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleOrderFlowLocationHeadline }}</p>
                <LocationPicker :locations="locations" :pickedLocation="order.location"
                    @locationChange="handleLocationChange" />
                <div>
                    <div v-if="order.location.id == flowConstants.testDriveAtShop && order.location.value == null">
                        <InquiryTarget :showFirstLabel="true" :branchesNodeId="branchesNodeId" :preAllowedType="2"
                            @changeShop="handleChangeShop" />
                    </div>
                    <div class="vehicle-page-flow__department-card"
                        v-if="order.location.id == flowConstants.testDriveAtShop && order.location.value != null && shop != null">
                        <p>{{ shop.name }}</p>
                        <ul>
                            <li>{{ shop.department.address }}</li>
                            <li>{{ shop.department.zipCode }} {{ shop.department.city }}</li>
                            <li>CVR: {{ shop.department.cvr }}</li>
                            <li>Telefon: <a :href="`tel:${shop.department.phone}`">{{ shop.department.phone }}</a></li>
                            <li>E-mail: <a :href="`mailto:${shop.department.email}`">{{ shop.department.email }}</a>
                            </li>
                        </ul>
                        <Button class="p-button-secondary p-button-outlined p-button-sm"
                            @click="handleLocationChange(locations.find(x => x.id == flowConstants.testDriveAtShop))">{{
        dictionary.vehicleOrderFlowChangeLocationButtonText }}</Button>
                    </div>
                </div>
            </div>
        </div>
        <!-- STEP 2 -->
        <div v-if="currentStep == 1" class="vehicle-page-flow__content">
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleOrderFlowServicesHeadline }}</p>
                <p class="vehicle-page-flow__text">
                    {{ dictionary.vehicleOrderFlowServicesText }}
                </p>
                <div>
                    <div class="formgrid grid">
                        <div class="field-checkbox col" v-for="(service, index) in services" :key="index">
                            <Checkbox name="services" :value="service" :inputId="'service' + index"
                                v-model="order.services" />
                            <label :for="'service' + index">{{ service }}</label>
                        </div>
                    </div>
                </div>

            </div>
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleFlowCommonTradeInHeadline }}</p>
                <p class="vehicle-page-flow__text" v-html="dictionary.vehicleFlowCommonTradeInText">
                </p>
                <div class="formgrid grid">
                    <div class="field col-12 sm:col-6">
                        <label for="tradeInRegNumber">Indtast nummerplade</label>
                        <InputMask id="tradeInRegNumber" mask="aa 99 999" v-model="order.tradeInRegNumber"
                            placeholder="AA XX XXX" />
                    </div>
                </div>
            </div>
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleOrderFlowExtrasHeadline }}</p>
                <p class="vehicle-page-flow__text">
                    {{ dictionary.vehicleOrderFlowExtrasText }}
                </p>
                <div>
                    <div class="formgrid grid">
                        <div class="field-checkbox col-12">
                            <Checkbox name="services" value="Vinterhjul" inputId="service4" v-model="order.services" />
                            <label for="service4">Vinterhjul</label>
                        </div>
                        <div class="field col-12">
                            <Textarea aria-label="Kommentar"
                                :placeholder="dictionary.vehicleOrderFlowCommentPlaceholder" v-model="order.comment"
                                rows="5" cols="30" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- STEP 3 -->
        <div v-if="currentStep == 2" class="vehicle-page-flow__content">
            <PersonalInformationForm @personalInformationUpdated="handlePersonalInformationUpdate"
                :userModel="personalInformation" :dictionary="dictionary" />
            <FlowNewsletterSignup :dealerId="vehicle.DealerId" :vehicleBrandAlias="vehicle.BrandAlias"
                :selectedShopId="marketingConsent ? marketingConsent.shopId : null"
                @consentChanged="(consent) => { marketingConsent = consent; }">
            </FlowNewsletterSignup>
        </div>
        <!-- STEP 4 -->
        <div v-if="currentStep == 3" class="vehicle-page-flow__content">
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleFlowCommonConfirmHeadline }}</p>
                <div>
                    <div class="vehicle-page-flow__confirm-location">
                        <img :src="order.location.icon.url" :height="order.location.icon.height"
                            :width="order.location.icon.width" alt="" loading="lazy" />
                        <p v-html="order.location.name"></p>
                    </div>
                    <div class="vehicle-page-flow__department-card"
                        v-if="order.location.name == flowConstants.testDriveAtShop && order.location.value != null && shop != null">
                        <p>{{ shop.name }}</p>
                        <ul>
                            <li>{{ shop.department.address }}</li>
                            <li>{{ shop.department.zipCode }} {{ shop.department.city }}</li>
                            <li>CVR: {{ shop.department.cvr }}</li>
                            <li>Telefon: <a :href="`tel:${shop.department.phone}`">{{ shop.department.phone }}</a></li>
                            <li>E-mail: <a :href="`mailto:${shop.department.email}`">{{ shop.department.email }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="order.services.length > 0">
                    <p class="vehicle-page-flow__sub-headline">{{ dictionary.vehicleOrderFlowServicesHeadline }}</p>
                    <div class="formgrid grid">
                        <div class="field-checkbox col-12 sm:col-4" v-for="(service, index) in order.services"
                            :key="index">
                            <Checkbox :disabled="true" :value="service" v-model="order.services" />
                            <label>{{ service }}</label>
                        </div>
                    </div>
                </div>
                <div v-if="order.tradeInRegNumber != null && order.tradeInRegNumber != ''">
                    <p class="vehicle-page-flow__sub-headline">{{ dictionary.vehicleFlowCommonTradeInHeadline }}</p>
                    <div class="formgrid grid">
                        <div class="field col">
                            <label>Nummerplade</label>
                            <p>{{ order.tradeInRegNumber }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="order.services.includes('Vinterhjul') || order.comment != null">
                    <p class="vehicle-page-flow__sub-headline">{{ dictionary.vehicleOrderFlowExtrasHeadline }}</p>
                    <div v-if="order.services.includes('Vinterhjul')" class="field-checkbox">
                        <Checkbox :disabled="true" value="Vinterhjul" v-model="order.services" />
                        <label>Vinterhjul</label>
                    </div>
                    <div v-if="order.comment != null" class="field">
                        <p>
                            "
                            {{ order.comment }}
                            "
                        </p>

                    </div>
                </div>

                <div>
                    <p class="vehicle-page-flow__sub-headline">
                        {{ dictionary.vehicleFlowCommonConfirmPersonalDetailsHeadline }}</p>
                    <div class="formgrid grid">
                        <div class="field col-12 sm:col-6">
                            <label>Fornavn</label>
                            <p>{{ order.firstName }}</p>

                        </div>
                        <div class="field col-12 sm:col-6">
                            <label>Efternavn</label>
                            <p>{{ order.lastName }}</p>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label>Email</label>
                            <p>{{ order.email }}</p>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label>Telefon</label>
                            <p>{{ order.phone }}</p>
                        </div>
                        <div v-if="order.address != null" class="field col-12 sm:col-6">
                            <label>Vejnavn</label>
                            <p>{{ order.address }}</p>
                        </div>
                        <div v-if="order.country != null" class="field col-12 sm:col-6">
                            <label>Land</label>
                            <p>{{ order.country }}</p>
                        </div>
                        <div v-if="order.city != null" class="field col-12 sm:col-6">
                            <label>By</label>
                            {{ order.city }}
                        </div>
                        <div v-if="order.zipCode != null" class="field col-12 sm:col-6">
                            <label>Postnummer</label>
                            <p>{{ order.zipCode }}</p>
                        </div>
                        <div v-if="marketingConsent" class="field col-12">
                            <label>Nyhedsbrev</label>
                            <p>Du tilmeldes nyhedsbrev for {{
        marketingConsent.departmentName }}</p>
                        </div>
                        <div class="field-checkbox col-12">
                            <Checkbox name="consent" :binary="true" inputId="consent" v-model="consent" />
                            <label for="consent" v-html="consentText"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Step 5 -->
        <div v-if="currentStep == 4" class="vehicle-page-flow__content">
            <div class="vehicle-page-flow__confirmation">
                <img src="/assets/images/checkmark.svg" width="45" height="45" alt="" loading="lazy">
                <div class="rte" v-html="confirmationText"></div>
                <Button class="p-button-secondary p-button-outlined" @click="endFlow">{{
        dictionary.vehicleFlowCommonEndFlowButtonText
    }}</Button>
            </div>
        </div>
        <div v-if="currentStep != 4" class="vehicle-page-flow__navigation">
            <Button class="p-button-secondary" v-if="currentStep == 0"
                :disabled="Object.keys(order.location).length == 0 || (order.location.id == 'Ved lokal afdeling' && order.location.value == null)"
                @click="changeStep(true)" :label="dictionary.vehicleFlowCommonInitButtonText"></Button>
            <Button class="p-button-secondary p-button-outlined" v-if="currentStep > 0" :disabled="isLoading"
                @click="changeStep(false)" :label="dictionary.vehicleFlowCommonPreviousButtonText"></Button>
            <Button class="p-button-secondary" :disabled="currentStep == 3 && !consent || isLoading"
                v-if="currentStep > 0" @click="changeStep(true)"
                :label="dictionary.vehicleFlowCommonNextButtonText"></Button>
        </div>
        <div v-if="faqItems.length > 0" class="vehicle-page-flow__footer">
            <FlowAccordion :items="faqItems" />
        </div>
    </Sidebar>
    <Toast position="top-center" />
</template>
<script>

import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import Checkbox from 'primevue/checkbox';
import InputMask from 'primevue/inputmask';
import Textarea from 'primevue/textarea';
import FlowAccordion from './components/flowAccordion.vue';
import FlowSteps from './components/flowSteps.vue';
import Toast from 'primevue/toast';
import InquiryTarget from './components/inquiryTarget';
import LocationPicker from './components/locationPicker';
import PersonalInformationForm from './components/personalInformationForm.vue';
import VueHelpers from './vueHelpers';
import FlowConstants from './flowConstants';
import Recaptcha from './../partials/recaptcha';
import FlowNewsletterSignup from './components/flowNewsletterSignup.vue';
const initOrderButtonSelector = ".vehicle-info__order-button";

export default {
    name: "orderVehicleFlow",
    components: {
        Button,
        Sidebar,
        Checkbox,
        InputMask,
        Textarea,
        FlowSteps,
        FlowAccordion,
        Toast,
        InquiryTarget,
        LocationPicker,
        PersonalInformationForm,
        FlowNewsletterSignup
    },
    data() {
        return {
            dictionary: [],
            vehicle: null,
            showSidebar: false,
            flowName: "orderVehicle",
            steps: [
                { id: 1, name: "Reservering og levering", queryAlias: "reservering-og-levering", visible: true },
                { id: 2, name: "Finansiering og udstyr", queryAlias: "finansiering-og-udstyr", visible: true },
                { id: 3, name: "Dine oplysninger", queryAlias: "dine-oplysninger", visible: true },
                { id: 4, name: "Bekræft oplysninger", queryAlias: "bekraeft-oplysninger", visible: true },
                { id: 5, name: "Bekræftelse", queryAlias: "bekraeftelse", visible: false }
            ],
            currentStep: 0,
            locations: null,
            culture: "da-DK",
            flowConstants: FlowConstants,
            faqItems: null,
            branchesNodeId: null,
            isSubmitted: false,
            services: ['Finansiering', 'Forsikring', 'Servicetilbud'],
            consent: false,
            consentText: null,
            confirmationText: "",
            marketingConsent: null,
            order: {
                location: {
                },
                services: [],
                tradeInRegNumber: null,
                comment: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                address: null,
                country: null,
                city: null,
                zipCode: null,
                personalInformationValid: false,
            },
            isLoading: false
        };
    },
    created() {
        const vm = this;
        VueHelpers.clearQueryString();
        vm.consentText = FlowConstants.defaultConsentText;
        vm.vehicle = JSON.parse(vm.$parent.vehicle);
        vm.culture = document.querySelector("html").getAttribute("lang");
        const nodeId = parseInt(vm.$parent.nodeId);
        vm.branchesNodeId = parseInt(vm.$parent.branchesNodeId);

        vm.locations = [
            { id: FlowConstants.testDriveOnLocation, name: vm.vehicle.DealerCity, value: null, icon: { url: "/assets/images/mapmarker.svg", height: 25, width: 18 } },
            { id: FlowConstants.testDriveAtShop, name: "En afdeling nær dig", value: null, icon: { url: "/assets/images/mapmarker.svg", height: 25, width: 18 } },
        ];

        fetch(`/umbraco/api/resourcesApi/GetVehicleOrderFlowResources?nodeId=${nodeId}`).then((response) => response.json())
            .then((data) => {
                vm.faqItems = data.faqItems;
                vm.consentText = data.consentText;
                vm.dictionary = data.dictionary;
                vm.confirmationText = data.confirmationText;
            })
            .catch((error) => {
                console.log(error);
            });

    },
    mounted() {
        const vm = this;
        const initOrderButtons = document.querySelectorAll(initOrderButtonSelector);
        if (initOrderButtons) {
            initOrderButtons.forEach(button => {
                button.addEventListener('click', e => {
                    vm.initFlow();
                });
            });
        }
    },
    methods: {
        handlePersonalInformationUpdate(response) {
            const vm = this;
            vm.order.firstName = response.info.firstName;
            vm.order.lastName = response.info.lastName;
            vm.order.email = response.info.email;
            vm.order.phone = response.info.phone;
            vm.order.address = response.info.address;
            vm.order.country = response.info.country;
            vm.order.city = response.info.city;
            vm.order.zipCode = response.info.zipCode;
            vm.order.personalInformationValid = response.isValid;
        },
        endFlow() {
            this.showSidebar = false;
            this.resetFlow();
        },
        resetFlow() {
            this.order = {
                location: {},
                services: [],
                tradeInRegNumber: null,
                comment: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                address: null,
                country: null,
                city: null,
                zipCode: null,
                personalInformationValid: false
            }
            this.consent = false;
            this.isSubmitted = false;
            this.currentStep = 0;
        },
        submitLead() {
            const vm = this;
            vm.toggleSpinner(true);

            const formData = new FormData();
            formData.append('LeadSourceUrl', window.location.href);
            formData.append('ModelId', vm.vehicle.Id);
            formData.append('ModelBrand', vm.vehicle.BrandAlias);
            formData.append('ModelName', `${vm.vehicle.ModelName} ${vm.vehicle.ModelTrim}`);
            formData.append('ModelYear', vm.vehicle.ModelYear);
            formData.append('Vin', vm.vehicle.Vin);
            formData.append('FirstName', vm.order.firstName);
            formData.append('LastName', vm.order.lastName);
            formData.append('Email', vm.order.email);
            formData.append('Phone', vm.order.phone);

            if (vm.order.location != null) {
                if (vm.order.location.id == FlowConstants.testDriveOnLocation) {
                    formData.append('DealerId', vm.vehicle.DealerId);
                    formData.append('SecondaryDealerKey', vm.vehicle.SecondaryDealerKey);
                    formData.append('DealerBrand',vm.vehicle.DealerBrand);

                }
                if (vm.order.location.id == FlowConstants.testDriveAtShop) {
                    formData.append('DealerId', vm.order.location.value.id);
                    formData.append('DealerBrand', vm.order.location.value.brand.fullBrandAliasCleaned);
                    formData.append('SecondaryDealerKey', vm.order.location.value.secondaryDealerKey);
                }
            } else {
                //Fallback if something goes totally wrong.
                formData.append('DealerId', vm.vehicle.DealerId);
                formData.append('SecondaryDealerKey', vm.vehicle.SecondaryDealerKey);
                formData.append('DealerBrand',vm.vehicle.DealerBrand);
            }

            const comment = []

            if (vm.order.street != null) {
                comments.push(`Street: ${vm.order.street}`);
            }
            if (vm.order.zipCode != null) {
                comment.push(`PostalCode: ${vm.order.zipCode}`);
            }
            if (vm.order.city != null) {
                comment.push(`City ${vm.order.city}`);
            }
            if (vm.order.country != null) {
                comment.push(`Country ${vm.order.country}`);
            }
            if (vm.order.tradeInRegNumber != null) {
                comment.push(`Trade in reg no: ${vm.order.tradeInRegNumber}`);
            }
            if (vm.order.services.length > 0) {
                comment.push(`Services: ${vm.order.services.join(',')}`);
            }
            if (vm.order.comment != null) {
                comment.push(`Comment: ${vm.order.comment}`);
            }

            formData.append('Comment', comment.join('\n'))

            Recaptcha.GetToken('orderVehicleFlow', (token) => {
                formData.append('RecaptchaToken', token);

                fetch("/umbraco/api/leadsApi/PostCreateUsedCarOffer", {
                    method: "POST",
                    body: formData
                }).then(data => {
                    if (data.status == 200) {

                        //If the lead was submitted, let's submit the marketing consent
                        if (vm.marketingConsent) {
                            const consentPostModel = {
                                firstName: vm.order.firstName,
                                lastName: vm.order.lastName,
                                email: vm.order.email,
                                brand: vm.marketingConsent.brand,
                                consentTextId: vm.marketingConsent.consentTextId,
                                shopId: vm.marketingConsent.shopId
                            };

                            fetch('/umbraco/api/consentApi/createCustomerConsent', {
                                method: 'post',
                                headers: {
                                    "Content-Type": "application/json",
                                    "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                                },
                                body: JSON.stringify(consentPostModel)
                            });
                            //We fail or succeed silently, as failed newsletter signup aint as severe as a failed lead.
                            //Errors are logged in Umbraco anyways
                        }


                        vm.isSubmitted = true;
                        vm.changeStep(true);
                    } else {
                        vm.$toast.add({ severity: 'error', summary: vm.dictionary.vehicleFlowCommonSubmitErrorTitle, detail: vm.dictionary.vehicleFlowCommonSubmitErrorText, life: 10000 });
                    }

                    vm.toggleSpinner(false);
                }).catch(error => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
            });
        },
        changeStep(forward) {
            const vm = this;
            if (forward) {
                if (vm.currentStep == 2) {
                    if (!vm.order.personalInformationValid) {
                        vm.$toast.add({ severity: 'error', summary: vm.dictionary.vehicleFlowCommonPersonalDetailMissingErrorTitle, detail: vm.dictionary.vehicleFlowCommonPersonalDetailMissingErrorText, life: 10000 });
                        return false;
                    }
                }
                if (vm.currentStep == 3 && !vm.isSubmitted) {
                    vm.submitLead();
                    return false;
                }
                vm.currentStep++;
            } else {
                vm.currentStep--;
            }
            VueHelpers.updateQueryString(FlowConstants.flowStepQueryKey, this.steps[this.currentStep].queryAlias, false);

            VueHelpers.scrollToTopOfFlow();
        },
        handleChangeShop(shop) {
            if (shop.id != -1) {
                this.shop = {
                    name: shop.name,
                    department: shop.departments.find(x => x.type = 2)
                }

                this.order.location.value = shop;

            } else {
                this.order.location.value = null;
            }
        },
        handleLocationChange(location) {
            const vm = this;
            vm.order.location = location;
            vm.order.location.value = null;
            switch (location.id) {
                case FlowConstants.testDriveAtShop:
                    vm.shop = null;
                    break;
                default:
                    break;
            }
        },
        initFlow() {
            this.showSidebar = true;
            VueHelpers.updateQueryString(FlowConstants.flowNameQueryKey, this.flowName, false);
            VueHelpers.updateQueryString(FlowConstants.flowStepQueryKey, this.steps[this.currentStep].queryAlias, false);


        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        personalInformation() {
            return {
                firstName: this.order.firstName,
                lastName: this.order.lastName,
                email: this.order.email,
                phone: this.order.phone,
                address: this.order.address,
                country: this.order.country,
                city: this.order.city,
                zipCode: this.order.zipCode
            }
        }
    }
};
</script>
